export default __webpack_public_path__ + "static/Swoosh-8162c3fc7e518e6374270ddac92360ee.svg";